import { useState } from "react";

function MasteringOptionsChainModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "1. Introduction to Options Chain",
      content: [
        "What is an Options Chain?: Overview of the options chain layout.",
        "Key components: Strike Price, Expiration Date, Bid-Ask Spread, Volume, and Open Interest.",
        "Differences between ITM (In-the-Money), ATM (At-the-Money), and OTM (Out-of-the-Money) options.",
        "Understanding the significance of Calls and Puts on the options chain.",
      ],
    },
    {
      title: "2. Reading and Interpreting Options Chain Data",
      content: [
        "How to access options chains on popular trading platforms (NSE, BSE, Thinkorswim, Zerodha).",
        "Analyzing Bid-Ask Spread: Understanding liquidity and transaction costs.",
        "Volume vs. Open Interest: Differentiating between active trading and longer-term interest.",
        "Spotting unusual volume and open interest spikes for potential trading opportunities.",
      ],
    },
    {
      title: "3. Using Options Greeks in the Options Chain",
      content: [
        "Understanding Delta: Measuring sensitivity to stock price movements.",
        "Using Delta to gauge directional bias and probability of being ITM.",
        "Gamma: Assessing changes in Delta and the impact of volatility.",
        "Theta (Time Decay): Analyzing how time affects options value.",
        "Vega: Understanding volatility's impact on premium.",
        "Practical examples of how to use Greeks for selecting the right options.",
      ],
    },
    {
      title: "4. Identifying Market Sentiment with Options Chain",
      content: [
        "Put-Call Ratio: Using the options chain to gauge market sentiment.",
        "Max Pain Theory: Predicting stock price movement towards maximum pain point on expiration.",
        "Identifying support and resistance levels using open interest clusters.",
        "Using options data to anticipate potential breakouts or reversals.",
      ],
    },
    {
      title: "5. Strategies Based on Options Chain Analysis",
      content: [
        "Bullish Strategies: Choosing the best strikes for long calls, bull call spreads, and covered calls.",
        "Bearish Strategies: Selecting optimal puts, bear put spreads, and protective puts.",
        "Neutral Strategies: Utilizing iron condors, butterflies, and calendar spreads based on OI and IV.",
        "Case studies: How options chain analysis can guide strategy selection.",
      ],
    },
    {
      title: "6. Spotting Unusual Options Activity",
      content: [
        "Unusual Options Activity (UOA): Identifying large block trades and unusual volume.",
        "Recognizing potential insider trading or institutional interest through the options chain.",
        "Dark Pool Data: Supplementing options chain analysis with hidden market orders.",
        "Examples of trades based on unusual options activity and their outcomes.",
      ],
    },
    {
      title: "7. Implied Volatility and the Options Chain",
      content: [
        "IV Rank and IV Percentile: How to use IV data from the options chain to time trades.",
        "Strategies for trading high vs. low implied volatility environments.",
        "Volatility Skew: Understanding how different strikes and expirations have varied IV.",
        "Adjusting trades based on volatility shifts observed in the options chain.",
      ],
    },
    {
      title: "8. Using the Options Chain for Earnings and Event Trading",
      content: [
        "Analyzing the options chain for earnings trades (pre- and post-announcement).",
        "Implied Move Calculation: Using options prices to predict stock movement around events.",
        "Strategies like straddles, strangles, and iron condors for earnings trades.",
        "Real-life examples of successful event-based trades using options chain insights.",
      ],
    },
    {
      title: "9. Advanced Options Chain Techniques",
      content: [
        "Synthetic Positions: Creating synthetic long/short positions using options chain data.",
        "Roll Strategies: Using the options chain to adjust and roll positions to different strikes or expirations.",
        "Delta Neutral Hedging: Identifying opportunities for delta-neutral trades.",
        "Building complex multi-leg strategies directly from the options chain.",
      ],
    },
    {
      title: "10. Live Market Analysis and Case Studies",
      content: [
        "Real-Time Options Chain Walkthrough: Interpreting live options chain data for trading decisions.",
        "Case studies: Success stories and lessons from options chain-driven trades.",
        "Interactive sessions: Practice reading and analyzing options chains in live market scenarios.",
        "Developing a personalized trading approach using insights from options chain analysis.",
      ],
    },
    {
      title: "11. Tools and Resources for Mastering Options Chain",
      content: [
        "Best platforms for accessing detailed options chain data (e.g., NSE, Thinkorswim, Sensibull).",
        "Using options scanners and screeners to find high-probability trades.",
        "Integrating options chain analysis with technical and fundamental analysis.",
        "Recommended books, websites, and courses for further mastery of options trading.",
      ],
    },
  ];

  return (
    <div className="container-fluid">
      <div className="container py-5">
        <h1 className="text-center mb-5">Mastering Options Chain</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div key={index} className="col-12 col-md-5 mb-3">
              {/* Module Header */}
              <div
                className="p-3 d-flex justify-content-between align-items-center"
                style={{
                  background: "#e9ecef",
                  border: "1px solid #ced4da",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: "18px",
                    transform: openModule === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Module Content */}
              {openModule === index && (
                <div
                  className="p-3 mt-2"
                  style={{
                    background: "#ffffff",
                    border: "1px solid #ced4da",
                    borderRadius: "5px",
                  }}
                >
                  {module.content.map((item, i) => (
                    <p key={i} style={{ fontSize: "14px", margin: "5px 0" }}>
                      ➤ {item}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MasteringOptionsChainModule;
